/* Lucky Inger: variant image filter (product pages only, loaded from theme.liquid).
   Filters gallery thumbnails so only images whose alt text matches the selected
   Design value show. Alt text must exactly match the variant name (e.g. BLACK/CREAM).
   Spotlight 15.4.1 loads the gallery asynchronously, so this uses a
   MutationObserver plus a timed retry instead of a single DOMContentLoaded pass. */
(function() {
  // Variant image filter for caps/screenprint Design dropdown.
  // Filters gallery thumbnails by matching image alt text to the selected variant value.
  //
  // Key behaviours:
  //   • filterWithRetry runs the filter 5 times over 1.5s, Spotlight lazy-loads gallery
  //     images asynchronously so a single-shot filter fires before alt text is set.
  //   • MutationObserver disconnects after binding the select, but re-observes
  //     immediately so it catches Spotlight rebuilding the select on every variant
  //     change (Spotlight tears down and recreates the select element each time).
  //   • Only activates on pages with a Design select and does nothing on all other pages.

  function filterImagesByVariant(variantValue) {
    if (!variantValue) return;
    var variant = variantValue.trim().toUpperCase();
    document.querySelectorAll('li.product__media-item').forEach(function(item) {
      var img = item.querySelector('img');
      if (!img) return;
      var alt = img.alt.trim().toUpperCase();
      item.style.display = (alt === variant) ? '' : 'none';
      item.style.opacity = '1';
    });
  }

  function filterWithRetry(variantValue, retries) {
    filterImagesByVariant(variantValue);
    if (retries > 0) {
      setTimeout(function() {
        filterWithRetry(variantValue, retries - 1);
      }, 300);
    }
  }

  function bindDesignSelect() {
    var select = document.querySelector('select[name="options[Design]"]');
    if (!select || select._variantFilterBound) return;
    select._variantFilterBound = true;

    // Disconnect while we work, then immediately re-observe.
    // Re-observing is critical, Spotlight rebuilds the select element on every
    // variant change, wiping _variantFilterBound, so we need to catch the next rebuild.
    observer.disconnect();
    observer.observe(document.body, { childList: true, subtree: true });

    // Hide thumbnails briefly to prevent flash of wrong images
    document.querySelectorAll('li.product__media-item').forEach(function(item) {
      item.style.opacity = '0';
    });

    filterWithRetry(select.value, 5);

    select.addEventListener('change', function() {
      filterWithRetry(this.value, 5);
    });
  }

  var observer = new MutationObserver(function() {
    var select = document.querySelector('select[name="options[Design]"]');
    if (select && !select._variantFilterBound) {
      bindDesignSelect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  bindDesignSelect();
  document.addEventListener('DOMContentLoaded', bindDesignSelect);
  window.addEventListener('load', bindDesignSelect);
})();
